import { Progress } from 'antd';
import styled, { css } from 'styled-components';

export const StyledStepsProgressBar = styled(Progress)`
  width: 100%;

  .ant-progress-steps-outer {
    justify-content: space-between;
  }
  /* We have to use !important for the time being until this antd issue is resolved
  https://github.com/ant-design/ant-design/issues/30499 */
  .ant-progress-steps-item {
    ${({ steps = 1 }) => css`
      width: ${90 / steps}% !important;
    `}
    /* width: 11% !important; */
    border-radius: 2px;
  }
`;
